import { style } from "@vanilla-extract/css";
import { vars } from "../../../styles/theme.css";

export const infoTextButton = style({
  display: "inline-block",
  outline: "none",
  border: 0,
  backgroundColor: "transparent",
  padding: 0,
  color: "inherit",
  selectors: {
    "&:focus-visible": {
      outline: `2px solid ${vars.colors.primary}`,
      outlineOffset: "2px",
      borderRadius: vars.radii.xs,
    },
  },
  "@media": {
    "(hover: hover)": {
      cursor: "help",
      textDecoration: "underline dotted",
      textDecorationColor: "currentColor",
      textUnderlineOffset: "0.2em",
    },
  },
});
